<template>
  <div>

    <CRow v-for="(objs, competencyIndex) in idpLocal" :key="competencyKey(objs, competencyIndex)" >
      <CCol col="12"  @click="toggleDetails(objs)" >
        <CIcon name="cil-layers" class="mr-2"/> <label class="font-weight-bold mt-1">{{ objs.title.filter(item => { return (item.key === lang)})[0].value }} </label>
      </CCol>

      <CCol col="12" v-if="objs.description.length > 0" @click="toggleDetails(objs)">
        <div v-html="objs.description.filter(item => { return (item.key === lang)})[0].value"></div>
      </CCol>
      <CCol>
        <CDropdownDivider/>
      </CCol>

      <CCol col="12">

<!--        <CCollapse :show="Boolean(objs._toggled)" :duration="collapseDuration">-->
          <CRow v-for="(objsLevel, levelIndex) in objs.levels" :key="levelKey(objs, competencyIndex, objsLevel, levelIndex)" class=" ">

            <CCol col="12" >
              <label class="font-weight-bold mt-1 h6">
                <CIcon name="cil-tags" class="mr-2"/> {{ objsLevel.title.filter(item => { return (item.key === lang)})[0].value }}
              </label>
            </CCol>

            <CCol col="12"  v-for="(item, itemIndex) in objsLevel.item" :key="levelItemKey(objs, competencyIndex, objsLevel, levelIndex, item, itemIndex)" class="mt-2">
              <IDPFrom :objs="item" @remove="onRemove" />
            </CCol>
          </CRow>
<!--        </CCollapse>-->
      </CCol>
    </CRow>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import IDPFrom from "@/projects/views/E-Performances/Estimate/components/sub/IDPFrom.vue";

export default {
  name: 'IDPInfomation',
  components: {IDPFrom},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Individual Development Plan'
    },
    index: {
      type: Number,
      default:0
    },
    idp: {
      type: Object/Array,
      default() {
        return null
      }
    },
  },

  data: function () {
    return {
      collapseDuration: 0,
      idpLocal: Array.isArray(this.idp) ? this.idp.slice() : [],
    }
  },

  mounted() {
  },

  created() {
  },

  beforeDestroy() {
  },

  methods: {
    toggleDetails (item) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    },

    currentRecordKey() {
      const currentIdp = this.$store.getters["idp/idp"] || {};
      return currentIdp._id || 'idp';
    },

    itemIdentity(item, fallback) {
      if (!item) {
        return fallback;
      }

      return item._id || item.id || item.code || item.value || fallback;
    },

    competencyKey(item, competencyIndex) {
      return `${this.currentRecordKey()}-${this.index}-competency-${this.itemIdentity(item, competencyIndex)}-${competencyIndex}`;
    },

    levelKey(parent, competencyIndex, level, levelIndex) {
      return `${this.competencyKey(parent, competencyIndex)}-level-${this.itemIdentity(level, levelIndex)}-${levelIndex}`;
    },

    levelItemKey(parent, competencyIndex, level, levelIndex, item, itemIndex) {
      return `${this.levelKey(parent, competencyIndex, level, levelIndex)}-item-${this.itemIdentity(item, itemIndex)}-${itemIndex}`;
    },

    onRemove(value) {
      this.idpLocal = this.idpLocal.map(item => {
        return {
          ...item,
          levels: item.levels.map(level => {
            return {
              ...level,
              item: level.item.filter(litem => litem._id.toString() !== value._id.toString())
            };
          }).filter(level => level.item.length > 0) // กรอง level ที่ไม่มี item
        };
      }).filter(item => item.levels.length > 0); // กรอง item ที่ไม่มี levels

      this.$emit('update', this.idpLocal,this.index )
    }

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {
    lang(value){

    },

    idp: function (newVal) {
      this.idpLocal = Array.isArray(newVal) ? newVal.slice() : [];
    }
  }
}
</script>
<style>

</style>
